import { Component } from "react";

import { PendingProviderChanges } from "@app/projects/servicing-provider/PendingProviderChanges";
import { FlyoutLink } from "@app/shared/Flyouts";

interface PendingProviderChangesSidePanelLinkProps {
  getTargets: boolean;
  getTerminations: boolean;
  projectId: number;
  processProviderChanges: (reprocessFailure: boolean) => Promise<void>;
  resetStatusBanners: (hasUnprocessedTerminations: boolean, hasUnprocessedTargets: boolean) => void;
  isZipProject: boolean;
}

//this wrapper component exists to prevent state updates re-rendering the Overview page, rather than doing a risky state comparison in a componentDidUpdate in the overview page
export default class PendingProviderChangesSidePanelLink extends Component<PendingProviderChangesSidePanelLinkProps> {
  constructor(props: PendingProviderChangesSidePanelLinkProps) {
    super(props);
  }

  public render() {
    return (
      <FlyoutLink
        classNames="text-info ml-3"
        content={{
          body: (
            <PendingProviderChanges
              getTargets={this.props.getTargets}
              getTerminations={this.props.getTerminations}
              projectId={this.props.projectId}
              processProviderChanges={this.props.processProviderChanges}
              resetStatusBanners={this.props.resetStatusBanners}
              isZipProject={this.props.isZipProject}
            />
          ),
          title: "Pending Provider Changes",
        }}
        testId="pending-provider-changes-flyout"
      >
        <i className="fa fa-rocket" /> View and Process
      </FlyoutLink>
    );
  }
}

